<template>
<div>
  <div class="modal fade" data-backdrop="static" id="modal-checkin-reservation">
        <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title">{{$t('apartment.reservations.update_information_checkin')}}</h1>
              </div>
              <div class="modal-body">
                <b-form>
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Customer name -->
                      <b-form-group label-size="sm" label-for="input-sm" :label="$t('apartment.reservations.customer_name')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="customerName"
                              class = "form-control"
                              disabled
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- EMAIL -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="'Email'">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="email"
                              class = "form-control"
                              disabled
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- PHONE -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('apartment.reservations.phone')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="phone"
                              class = "form-control"
                              disabled
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Date time checkin -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('apartment.reservations.date_checkin')">
                        <div class="form-group">
                          <date-picker
                            :config="options"
                            :value="dateCheckIn"
                            v-model="dateCheckIn"
                            :disabled="disabledCheckin == true"
                          ></date-picker>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Date time checkout -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('apartment.reservations.date_checkout')">
                        <div class="form-group">
                          <date-picker
                            :config="options"
                            :value="dateCheckOut"
                            v-model="dateCheckOut"
                            :disabled="disabledCheckin == true"
                          ></date-picker>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <!-- Booking other details -->
                  <b-form-group label-size="sm" label-for="input-sm"  :label="$t('apartment.reservations.note')">
                    <div class="form-group">
                      <div>
                        <textarea v-model="otherBookingDetails" :placeholder="$t('apartment.reservations.special_notes')" class="md-textarea form-control" rows="3"></textarea>
                      </div>
                    </div>
                  </b-form-group>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                  v-if="booking_status == BookingStatusEnum.ONBOARD || !disabledCheckin"
                  type="button"
                  @click="updateInformationCheckinCheckOut(null)"
                  :class="booking_status == BookingStatusEnum.ONBOARD || !disabledCheckin ? 'btn btn-primary btn-sm pull-right mg-left' : 'btn btn-primary btn-sm pull-right'"
                >{{$t('common.save')}}</button>
                <button
                  v-if="booking_status != BookingStatusEnum.ONBOARD"
                  type="button"
                  @click="onShowModalConfirm(null)"
                  :class="booking_status != BookingStatusEnum.ONBOARD ? 'btn btn-primary btn-sm pull-right mg-left' : 'btn btn-primary btn-sm pull-right'"
                >{{$t('apartment.reservations.confirm_checkin')}}</button>
                <button
                  v-if="booking_status == BookingStatusEnum.ONBOARD"
                  type="button"
                  @click="onShowModalConfirm('check_out')"
                  class="btn btn-primary btn-sm pull-right"
                >{{$t('apartment.reservations.checked_out')}}</button>
                <button
                  v-if="booking_status != BookingStatusEnum.ONBOARD"
                  type="button"
                  @click="onShowModalConfirm('cancel_booking_room')"
                  class="btn btn-primary btn-sm pull-right"
                >{{$t('apartment.reservations.cancelled_room')}}</button>
                <button
                  v-if="booking_status != BookingStatusEnum.ONBOARD"
                  type="button"
                  @click="updateDateCheckinCheckout()"
                  class="btn btn-primary btn-sm pull-right"
                >{{$t('apartment.reservations.update_check_in_out_datetime')}}</button>
                <button
                  type="button"
                  class='btn btn-warning btn-sm pull-left'
                  @click="closeModal"
                >{{$t('common.back')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
        </div>
    </div>
    <div class="modal fade" id="modal-confirm">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title">{{typeUpdate == null ? $t('apartment.reservations.confirm_checkin') : (typeUpdate == 'check_out' ? $t('apartment.reservations.checkout') : $t('apartment.reservations.cancelled_room'))}}</h1>
              </div>
              <div class="modal-body">
                <b-form>
                  <b-form-group label-size="sm" label-for="input-sm" :label="typeUpdate == null ? $t('apartment.reservations.confirm_sure_checkin') + `, ${$t('reportmonthly.apartment_name')} ${apartmentCode}` + '?' : (typeUpdate == 'check_out' ? $t('apartment.reservations.confirm_sure_checkout') + `, ${$t('reportmonthly.apartment_name')} ${apartmentCode}` : $t('apartment.reservations.confirm_sure_cancelled') + `, ${$t('reportmonthly.apartment_name')} ${apartmentCode}`) + '?'"> 
                  </b-form-group>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  @click="updateInformationCheckinCheckOut(typeUpdate)"
                  class="btn btn-primary btn-sm pull-right"
                >Xác Nhận</button>
                <button
                  type="button"
                  class='btn btn-warning btn-sm pull-left'
                  @click="closeConfirmModal"
                >{{$t('common.back')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
        </div>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'
import BookingStatusEnum from "@/enum/bookingStatusEnum";

export default {
  name: 'lte-modal',
  data() {
    return {
        customerName: '',
        apartmentCode: '',
        email: '',
        phone: '',
        dateCheckOut: null,
        dateCheckIn: null,
        otherBookingDetails: '',
        BookingStatusEnum: BookingStatusEnum,
        booking_status: BookingStatusEnum.UNDEFINED,
        disabledCheckin: true,
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        bookingId: null,
        typeUpdate: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    submit(booking_id) {
        this.bookingId = booking_id
        if (booking_id != null) {
            this.GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL({id: booking_id}).then(
                function(res) {
                    let data = res.data;
                    this.customerName = data.apartment_booking.booking_person_name
                    this.email = data.apartment_booking.booking_person_email
                    this.phone = data.apartment_booking.booking_person_phone
                    this.apartmentCode = data.apartment.apartment_code;
                    this.dateCheckOut = utils.formatSqlDate(data.apartment_booking.checkout_datetime, null, this.options.format);
                    this.dateCheckIn = utils.formatSqlDate(data.apartment_booking.checkin_datetime, null, this.options.format);
                    this.otherBookingDetails = data.apartment_booking.other_booking_details
                    this.booking_status = data.booking_status
                    $("#modal-checkin-reservation").modal("show");
                }.bind(this)
            ).catch(
                function(error) {
                    this.ERROR_TOAST()
                }.bind(this)
            )
        }
    },
    updateInformationCheckinCheckOut: function(status_booking) {
      let currentDate = moment(new Date(), 'DD-MM-YYYY').format('DD-MM-YYYY')
      let dateCheckOut = utils.formatSqlDate(this.dateCheckOut, 'DD-MM-YYYY', 'DD-MM-YYYY')
      if (currentDate > dateCheckOut && !this.disabledCheckin) {
        this.ON_SHOW_TOAST({
          message: this.$t('apartment.reservations.checkout_date_exceeds_current_date'),
          styleType: "danger"
        });
      } else {
        let data = {
          other_booking_details: this.otherBookingDetails,
          booking_code: this.booking_status,
          status: status_booking,
          checkin_datetime: utils.formatSqlDate(this.dateCheckIn, 'DD/MM/YYYY', "DD/MM/YYYY"),
          checkout_datetime: utils.formatSqlDate(this.dateCheckOut, 'DD/MM/YYYY', "DD/MM/YYYY")
        }
        if (!this.disabledCheckin) {
          data['is_update_checkin_checkout_datetime'] = 'True'
        } else {
          data['is_update_checkin_checkout_datetime'] = 'False'
        }
        this.UPDATE_APARTMENT_RESERVATION({id: this.bookingId, ...data}).then(
          function(res) {
            // Update success
            $("#modal-checkin-reservation").modal("hide");
            $("#modal-confirm").modal("hide");
            this.disabledCheckin = true
            this.SUCCESS_TOAST()
            this.$emit('callbackGetLeaseBackAvailableApartment')
            this.$emit('callbackGetApartmentReservation')
          }.bind(this)
        ).catch(
          function(error) {
            $("#modal-checkin-reservation").modal("hide");
            $("#modal-confirm").modal("hide");
            this.disabledCheckin = true
            let error_data = error.response.data
            if (!utils.isNull(error_data.error_code) && error_data.error_code == "checkout_late") {
              this.ON_SHOW_TOAST({
                message: this.$t('apartment.reservations.invalid_checkout_time'),
                styleType: "danger"
              });
            } else if (!utils.isNull(error_data.error_code) && error_data.error_code == "invalid_checkin_time") {
              this.ON_SHOW_TOAST({
                message: this.$t('apartment.reservations.invalid_checkin_time'),
                styleType: "danger"
              });
            } else if (!utils.isNull(error_data.error_code) && error_data.error_code == "checked_out") {
              this.ON_SHOW_TOAST({
                message: this.$t('apartment.reservations.invalid_checked_out'),
                styleType: "danger"
              });
            } else if (!utils.isNull(error_data.error_code) && error_data.error_code == "cancelled_room") {
              this.ON_SHOW_TOAST({
                message: this.$t('apartment.reservations.invalid_cancelled_room'),
                styleType: "danger"
              });
            } else if (!utils.isNull(error_data.error_code) && error_data.error_code == "cannot_checkout") {
              this.ON_SHOW_TOAST({
                message: this.$t('apartment.reservations.cannot_check_out'),
                styleType: "danger"
              });
            } else {
              // Show error toast
              this.ERROR_TOAST()
            }
          }.bind(this)
        )
      }
    },
    onShowModalConfirm: function(type) {
        this.typeUpdate = type
        $("#modal-confirm").modal("show");
    },
    updateDateCheckinCheckout: function() {
        this.disabledCheckin = false
    },
    closeModal: function() {
        $("#modal-checkin-reservation").modal("hide");
        this.disabledCheckin = true
    },
    closeConfirmModal: function() {
        $("#modal-confirm").modal("hide");
    },
    ...mapActions([
      "GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL",
      "UPDATE_APARTMENT_RESERVATION",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST"
    ])
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  },
}
</script>
<style lang="scss" scoped>
    .mg-left {
        margin-left: 5px;
    }
    .hide-scroll-bar::-webkit-scrollbar { 
        display: none; 
    } 
</style>



// WEBPACK FOOTER //
// src/components/LTEModalBookingDetail.vue